export const FETCH_CROWDS_SUCCEEDED = 'FETCH_CROWDS_SUCCEEDED'